"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monterenzio": {
    "15081c4c": [{
      "hkey": "ac8d823c",
      "slug": "villa-di-cassano",
      "name": "Villa di Cassano",
      "primary": true,
      "skipSearch": false
    }],
    "cassano": [{
      "hkey": "ac8d823c",
      "slug": "villa-di-cassano",
      "name": "Villa di Cassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "29f5fdb4": [{
      "hkey": "30f4cb2e",
      "slug": "monterenzio",
      "name": "Monterenzio",
      "primary": true,
      "skipSearch": false
    }],
    "rignano-bolognese": [{
      "hkey": "30f4cb2e",
      "slug": "monterenzio",
      "name": "Monterenzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f0bca73": [{
      "hkey": "30f4cb2e",
      "slug": "monterenzio",
      "name": "Monterenzio",
      "primary": true,
      "skipSearch": false
    }],
    "vignale-sassuno": [{
      "hkey": "30f4cb2e",
      "slug": "monterenzio",
      "name": "Monterenzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;